import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var TextColorType = /** @class */ (function (_super) {
    __extends(TextColorType, _super);
    function TextColorType() {
        var _this = _super.call(this) || this;
        console.warn('[TextColorType] not implemented');
        return _this;
    }
    TextColorType.classInitializer = null;
    TextColorType.classSymbols = null;
    TextColorType.instanceSymbols = null;
    TextColorType.DARK_COLOR = 'dark';
    TextColorType.LIGHT_COLOR = 'light';
    return TextColorType;
}(ASObject));
export { TextColorType };
